import React from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo } from 'types';
import { SuggestedDishMultipleSelect } from './components/SuggestedDishMultipleSelect';
import { DnDList } from './components/DnDList';
import style from './index.module.scss';

interface IProps {
	setFetchedSuggestedDishes: (value: IItemForGetShortInfo[]) => void;
	setSuggestedDishCategory: (value: Nullable<string>) => void;
	setSuggestedDishSubCategory: (value: Nullable<string>) => void;
	setSuggestedDishes: (value: string[]) => void;
	removeSuggestedDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedSuggestedDishCategory: Nullable<string>;
	selectedSuggestedDishSubCategory: Nullable<string>;
	selectedSuggestedDishes: string[];
	fetchedSuggestedDishes: IItemForGetShortDishInfo[];
}

export const SuggestedDishesField: React.FC<IProps> = React.memo(
	({
		setFetchedSuggestedDishes,
		setSuggestedDishCategory,
		setSuggestedDishSubCategory,
		setSuggestedDishes,
		removeSuggestedDish,
		IDsSelectedRestaurant,
		selectedSuggestedDishCategory,
		selectedSuggestedDishSubCategory,
		selectedSuggestedDishes,
		fetchedSuggestedDishes,
	}) => {
		return (
			<div className={style.container} data-test="SuggestedDishesField">
				<SuggestedDishMultipleSelect
					setFetchedSuggestedDishes={setFetchedSuggestedDishes}
					setSuggestedDishCategory={setSuggestedDishCategory}
					setSuggestedDishSubCategory={setSuggestedDishSubCategory}
					setSuggestedDishes={setSuggestedDishes}
					removeSuggestedDish={removeSuggestedDish}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					selectedSuggestedDishCategory={selectedSuggestedDishCategory}
					selectedSuggestedDishSubCategory={selectedSuggestedDishSubCategory}
					fetchedSuggestedDishes={fetchedSuggestedDishes}
					selectedSuggestedDishes={selectedSuggestedDishes}
				/>
				<DnDList
					selectedSuggestedDishes={selectedSuggestedDishes}
					fetchedSuggestedDishes={fetchedSuggestedDishes}
					setSuggestedDishes={setSuggestedDishes}
					removeSuggestedDish={removeSuggestedDish}
				/>
			</div>
		);
	},
);
